export default __webpack_public_path__ + "static/media/check.b0036ad5.svg";